import React from 'react';
import { FaPlus } from 'react-icons/fa';
import './NewLaneSection.css';
import { useI18n } from '../../../../i18n';

const NewLaneSection = ({ onClick }) => {
	const { t } = useI18n();
	return (
	<div className="board-add-list-wrap">
		<button type="button" className="board-add-control" onClick={onClick}>
			<FaPlus /> {t('board.addList')}
		</button>
	</div>
	);
};

export default NewLaneSection;
